import React from "react";
import { K } from "../theme";
import { Av } from "./Avatar";

// "Reporting Manager · ZLGUR00102 - Anuprash Gupta" with their photo — shown
// on an employee's own profile and on the profile HR/admin open, so both
// views answer "who do they report to?" the same way. When `onClick` is
// given (and a manager is actually assigned), the whole block opens the
// manager's own profile — jumping up the reporting chain without leaving
// the modal.
export const ReportingManager = ({ id, name, photo, designation, compact, onClick }) => {
  if (!name && !id) {
    return (
      <div className="flex flex-col gap-[3px]">
        <span className="text-[11px] uppercase tracking-wide text-t3">Reporting Manager</span>
        <span className="text-[14px] text-t3 italic">Not assigned</span>
      </div>
    );
  }

  const clickable = typeof onClick === "function";

  return (
    <div
      className={`flex items-center gap-3${clickable ? " cursor-pointer group" : ""}`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      title={clickable ? "Open manager's profile" : undefined}
    >
      <div className="min-w-0 text-right">
        <div className="text-[11px] uppercase tracking-wide text-t3">Reporting Manager</div>
        <div className={`text-[14px] font-bold text-t0 truncate${clickable ? " group-hover:text-p" : ""}`}>
          {id && <span className="font-normal text-t2">{id} - </span>}{name || "—"}
        </div>
        {!compact && designation && <div className="text-[12px] text-t3 truncate">{designation}</div>}
      </div>
      <Av nm={name || id || "?"} sz={compact ? 34 : 42} rn={K.p} src={photo} />
    </div>
  );
};
